<template>
  <div class="main-container" :class="{ 'open-fade': isOpen }" ref="modalContainer" @click="handleClickOutside($event)">
    <div class="modal" :class="{ 'open-scale': isOpen }">
      <div class="close-button noselect" @click="cancel" v-if="!preventCancel">
        <span>&#128473;</span>
      </div>
      <h2>{{ text }}</h2>
      <h3 v-if="countDown > 0">Accept in {{ countDown }}</h3>
      <p v-html="paragraph"></p>
      <input :type="type || 'text'" v-if="input" :placeholder="input" v-model="inputValue" @keydown.enter="submit" />
      <component v-if="inputComponent" :is="inputComponent.component" v-bind="inputComponent.props"
        @input="inputComponentEventsProxy('input', $event)"></component>
      <div></div>
      <div class="space" :style="`height: ${space};`"></div>
      <div :class="[true && 'buttons-container', centerActions && 'center']">
        <button @click="cancel" v-if="!hideCancelButton" outline>Cancel</button>
        <button @click="submit" v-if="!hideOkButton" :disabled="loading">
          <span :class="{ 'opacity-0': loading }">{{
            confirmButtonContent
          }}</span>
          <div class="spring-spinner" v-if="loading">
            <div class="spring-spinner-part top">
              <div class="spring-spinner-rotator"></div>
            </div>
            <div class="spring-spinner-part bottom">
              <div class="spring-spinner-rotator"></div>
            </div>
          </div>
        </button>
        <button @click="response('reject')" v-if="acceptReject" outline :disabled="loading">
          <span :class="{ 'opacity-0': loading }">{{ $t("general.reject") }} </span>
          <div class="spring-spinner" v-if="loading">
            <div class="spring-spinner-part top">
              <div class="spring-spinner-rotator"></div>
            </div>
            <div class="spring-spinner-part bottom">
              <div class="spring-spinner-rotator"></div>
            </div>
          </div>
        </button>
        <button @click="response('accept')" v-if="acceptReject" :disabled="loading">
          <span :class="{ 'opacity-0': loading }">{{ $t("general.accept") }} </span>
          <div class="spring-spinner" v-if="loading">
            <div class="spring-spinner-part top">
              <div class="spring-spinner-rotator"></div>
            </div>
            <div class="spring-spinner-part bottom">
              <div class="spring-spinner-rotator"></div>
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import OrderCard from "@/components/OrderCard.vue";

export default {
  name: "DIALOVA_DIALOG_COMPONENT",
  components: {
    OrderCard,
  },
  data() {
    return {
      isOpen: false,
      countDown: null,
      resolvePromise: null,
      rejectPromise: null,
      acceptReject: false,
      text: "",
      paragraph: "",
      input: null,
      inputValue: "",
      loader: false,
      loading: false,
      type: "",
      hideCancelButton: false,
      hideOkButton: false,
      timeout: 0,
      centerActions: false,
      confirmButtonContent: "",
      callBackArgs: {},
      inputComponent: null,
      space: "0px",
      preventCancel: false
    };
  },
  methods: {
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      } else if (this.countDown == 0) {
        this.loading = false;
        this.isOpen = false;
      }
    },
    handleClickOutside(event) {
      if (this.$refs.modalContainer == event.target) {
        this.cancel();
      }
    },
    openDialog(options) {
      return new Promise((resolve, reject) => {
        this.isOpen = true;
        this.text = options.title;
        this.paragraph = options.paragraph;
        this.input = options.input || null;
        this.inputValue = "";
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
        this.loader = options.loader || false;
        this.loading = false;
        this.type = options.type || "";
        this.hideCancelButton = options.hideCancelButton || false;
        this.preventCancel = options.preventCancel || false;
        this.hideOkButton = options.hideOkButton || false;
        this.acceptReject = options.acceptReject || false;
        this.timeout = options.timeout || 0;
        this.centerActions = options.centerActions || false;
        this.confirmButtonContent = options.confirmButtonContent || "Ok";
        this.callBackArgs = options.callBackArgs || {};
        this.inputComponent = options.inputComponent || null;
        this.space = options.space || "0px";
        if (this.timeout > 0) {
          this.countDown = this.timeout;
          this.countDownTimer();
        }
      });
    },
    submit() {
      const obj = {
        value: this.inputValue,
        ...this.callBackArgs,
      };
      if (this.loader) {
        obj["close"] = this.close;
        this.loading = true;
      } else {
        this.isOpen = false;
      }
      this.resolvePromise(obj);
    },
    response(status) {
      const obj = {
        value: status,
        ...this.callBackArgs,
      };
      if (this.loader) {
        obj["close"] = this.close;
        this.loading = true;
      } else {
        this.isOpen = false;
      }
      this.resolvePromise(obj);
    },
    close() {
      this.loading = false;
      this.isOpen = false;
    },
    cancel() {
      if (this.preventCancel)
        return;
      this.rejectPromise();
      this.isOpen = false;
    },
    inputComponentEventsProxy(fn, evt) {
      this.inputComponent[fn](evt, this.callBackArgs);
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  font-family: Poppins;
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                 supported by Chrome, Edge, Opera and Firefox */
}

@keyframes openScale {
  from {
    transform: scale(0.8);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.opacity-0 {
  opacity: 0 !important;
}

.open-scale {
  transform: scale(1) !important;
  opacity: 1 !important;
  animation: 0.2s openScale;
}

.open-fade {
  opacity: 1 !important;
  pointer-events: all !important;
}

.main-container {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(#222, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: 0.4s;
  pointer-events: none;
  z-index: 60;

  .modal {
    padding: 36px 28px;
    background: white;
    width: max-content;
    min-width: 250px;
    max-width: 580px;
    height: fit-content;
    float: left;
    border-radius: 8px;
    margin-bottom: 4vh;
    position: relative;
    transform: scale(0.8);
    opacity: 0;
    transition: 0.2s;

    .close-button {
      right: 0;
      position: absolute;
      bottom: calc(100% + 12px);
      background: rgba(#fff, 0.8);
      border: 1px solid #fff;
      width: 26px;
      height: 26px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      cursor: pointer;
      color: #84969e;

      span {
        margin-bottom: 1px;
        font-size: 12px;
      }
    }

    h2 {
      width: 100%;
      float: left;
      color: #202731;
      font-size: 16pt;
      padding: 0;
      margin: 0;
      font-weight: 500;
    }

    p {
      margin-top: 8px;
      float: left;
      color: #84969e;
      font-size: 12pt;
      padding-bottom: 14px;

      b {
        color: #202731 !important;
        font-weight: 500;
      }
    }

    .space {
      float: left;
      width: 100%;
    }

    input {
      width: 100%;
      float: left;
      padding: 16px;
      background: #f7f8fa;
      border: 1px solid #c1c5d8;
      border-radius: 8px;
      transition: 0.2s;
      max-width: none;
      margin-top: 16px;

      &:focus {
        outline: none;
        border: 1px solid #ff9fa8;
        box-shadow: 0px 0px 2px #ff9fa8;
      }
    }

    .buttons-container {
      width: 100%;
      height: auto;
      margin-top: 22px;
      float: left;
      display: flex;
      justify-content: flex-end;
      gap: 8px;

      &.center {
        justify-content: center !important;
      }

      button {
        float: right;
        padding: 10px 28px;
        width: auto;
        background: #e10015;
        color: white;
        border: none;
        border-radius: 4px;
        font-weight: 400;
        cursor: pointer;
        transition: 0.1s;
        max-height: 43px;
        position: relative;

        &[outline] {
          background: #fff;
          border: 1px solid #e10015;
          color: #e10015;
        }

        &:hover {
          box-shadow: 0px 0px 6px rgba(#202731, 0.12);
        }
      }
    }
  }
}

/* Spinner */

.spring-spinner,
.spring-spinner * {
  box-sizing: border-box;
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
}

.spring-spinner {
  height: 100%;
  max-height: 18px;
  width: auto;
  max-width: 18px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: auto;
}

.spring-spinner .spring-spinner-part {
  overflow: hidden;
  max-height: 9px;
  height: 100%;
  width: auto;
  max-width: 18px;
}

.spring-spinner .spring-spinner-part.bottom {
  transform: rotate(180deg) scale(-1, 1);
}

.spring-spinner .spring-spinner-rotator {
  width: 18px;
  height: 18px;
  border: 2.5px solid transparent;
  border-right-color: white;
  border-top-color: darken(white, 15);
  border-radius: 50%;
  box-sizing: border-box;
  animation: spring-spinner-animation 3s ease-in-out infinite;
  transform: rotate(-200deg);
}

.custom-html {
  float: left;
  width: 100%;
}

@keyframes spring-spinner-animation {
  50% {
    transform: rotate(115deg);
  }
}
</style>
